import type { Staff, PaginatedResponse, StaffFilters } from "../../types";
import type { EndpointBuilder } from "@reduxjs/toolkit/query/react";


export const staffQueries = (builder: EndpointBuilder<any, string, string>) => ({
  getStaff: builder.query<PaginatedResponse<Staff>, StaffFilters>({
    query: (filters = {}) => ({
      url: "admin/staff",
      params: filters,
    }),
    providesTags: (result: any) =>
      result && result.data
        ? [
            ...result.data.map(({ id }: { id: string }) => ({ type: "Staff" as const, id })),
            { type: "Staff", id: "LIST" },
          ]
        : [{ type: "Staff", id: "LIST" }],
  }),

  getStaffById: builder.query<Staff, string>({
    query: (id: string) => `admin/staff/${id}`,
    providesTags: (_result: any, _error: any, id: string) => [{ type: "Staff", id }],
  }),
});